'use client';
import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

const Preloader = () => {
    const preloaderRef = useRef<HTMLDivElement>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!preloaderRef.current) return;

        const letters = preloaderRef.current.querySelectorAll<SVGPathElement>('path');
        const bars = preloaderRef.current.querySelectorAll<HTMLElement>('.preloader-item');
        const logo = preloaderRef.current.querySelector<HTMLElement>('.logo');

        if (letters.length === 0 || !logo) return;

        // Prepare SVG paths
        letters.forEach((path) => {
            const length = path.getTotalLength();
            gsap.set(path, {
                strokeDasharray: length,
                strokeDashoffset: length,
                stroke: '#f59e0b',
                strokeWidth: 1,
                fill: 'none',
                opacity: 1
            });
        });

        const tl = gsap.timeline({
            defaults: { ease: 'power1.inOut' },
            onComplete: () => setIsLoaded(true),
        });

        // Show logo container first
        tl.set(logo, { autoAlpha: 1 }); // sets opacity:1 and visibility:visible

        // Draw letters
        tl.to(letters, {
            strokeDashoffset: 0,
            duration: 3,
            stagger: 1,
        });

        tl.to(bars, {
            y: '100%',
            duration: 0.8,
            stagger: 0.1,
            ease: 'power2.inOut',
        }, '-=2');

        tl.to(preloaderRef.current, { autoAlpha: 0, duration: 0.4 }, '-=1.3');
    }, []);

    if (isLoaded) return null;

    return (
        <div className="fixed inset-0 z-[100] flex" ref={preloaderRef}>
            {[...Array(5)].map((_, i) => (
                <div key={i} className="preloader-item h-full w-[20%] bg-black"></div>
            ))}

            <div className="flex w-[250px] lg:w-[400px] h-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 leading-none overflow-hidden logo opacity-0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 8.84 184.67 37.03">
                    <g fill="#f0b100">
                        <g transform="translate(0, 0)">
                            <path d="M0 45.26L0 9.47L25.88 9.47L25.88 13.70L4.74 13.70L4.74 24.66L24.54 24.66L24.54 28.86L4.74 28.86L4.74 41.04L26.71 41.04L26.71 45.26L0 45.26ZM43.48 45.26L29.61 9.47L34.74 9.47L44.04 35.47Q45.17 38.60 45.92 41.33Q46.75 38.40 47.85 35.47L57.52 9.47L62.35 9.47L48.34 45.26L43.48 45.26ZM65.16 27.83Q65.16 18.92 69.95 13.88Q74.73 8.84 82.30 8.84Q87.26 8.84 91.24 11.21Q95.21 13.57 97.30 17.81Q99.39 22.05 99.39 27.42Q99.39 32.86 97.19 37.16Q95.00 41.46 90.97 43.66Q86.94 45.87 82.28 45.87Q77.22 45.87 73.24 43.43Q69.26 40.99 67.21 36.77Q65.16 32.54 65.16 27.83M70.04 27.91Q70.04 34.38 73.52 38.10Q77.00 41.82 82.25 41.82Q87.60 41.82 91.05 38.06Q94.51 34.30 94.51 27.39Q94.51 23.02 93.03 19.76Q91.55 16.50 88.71 14.71Q85.86 12.92 82.32 12.92Q77.29 12.92 73.67 16.37Q70.04 19.82 70.04 27.91ZM105.44 45.26L105.44 9.47L110.30 9.47L129.10 37.57L129.10 9.47L133.64 9.47L133.64 45.26L128.78 45.26L109.99 17.14L109.99 45.26L105.44 45.26ZM142.41 45.26L142.41 9.47L147.14 9.47L147.14 45.26L142.41 45.26ZM151.86 45.26L165.70 26.61L153.49 9.47L159.13 9.47L165.63 18.65Q167.65 21.51 168.51 23.05Q169.70 21.09 171.34 18.97L178.54 9.47L183.69 9.47L171.12 26.34L184.67 45.26L178.81 45.26L169.80 32.50Q169.04 31.40 168.24 30.10Q167.04 32.06 166.53 32.79L157.54 45.26L151.86 45.26Z" />
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    );
};

export default Preloader;
